<style type="text/css" lang="scss">
.tip-info {
  padding: 8px 16px;
  background-color: #fff6f7;
  border-radius: 4px;
  border-left: 5px solid #ff7800;
  margin: 11px 0;
}
</style>
<template>
  <el-tabs
    v-model="activeName"
    type="border-card"
    @tab-click="handleClick"
  >
    <el-tab-pane
      label="本地图片"
      name="qiniu"
    >
      <!-- <div class="tip-info">
          <p>当前本地图片已存储数量为<span style="font-size:20px;padding-left: 5px;">555张</span></p>
          <p>当前本地图片剩余储<span style="font-size:20px;padding-left: 5px;">22张</span></p>
      </div>-->
      <localimages-list
        :active-name="activeName"
        :get-status="localpicStatus"
      />
    </el-tab-pane>
    <el-tab-pane
      label="本地视频"
      name="localvideo"
    >
      <localvideos-list
        :active-name="activeName"
        :get-status="localvideoStatus"
      />
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import localimagesList from './localimages/list.vue'
import localvideosList from './localvideos/list.vue'
export default {
  components: {
    localimagesList,
    localvideosList
  },
  data () {
    return {
      activeName: 'qiniu',
      stats: [],
      picStatus: false,
      newsStatus: true,
      videoStatus: false,
      localpicStatus: false,
      localvideoStatus: false,
      Status: false
    }
  },
  mounted () {
    this.activeName = 'qiniu'
    this.handleClick()
  },
  methods: {
    handleClick () {
      if (this.activeName == 'picture') {
        this.picStatus = true
        this.newsStatus = false
        this.videoStatus = false
        this.localpicStatus = false
        this.localvideoStatus = false
      } else if (this.activeName == 'imagetext') {
        this.picStatus = false
        this.videoStatus = false
        this.newsStatus = true
        this.localpicStatus = false
        this.localvideoStatus = false
      } else if (this.activeName == 'video') {
        this.picStatus = false
        this.videoStatus = true
        this.newsStatus = false
        this.localpicStatus = false
        this.localvideoStatus = false
      } else if (this.activeName == 'localvideo') {
        this.picStatus = false
        this.videoStatus = false
        this.newsStatus = false
        this.localpicStatus = false
        this.localvideoStatus = true
      } else {
        this.picStatus = false
        this.videoStatus = false
        this.newsStatus = false
        this.localpicStatus = true
        this.localvideoStatus = false
      }
    }
  }
}
</script>
